import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function TopicShowcase() {
  const featured = topics.slice(0, 3);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {featured.map((topic) => (
        <Link
          key={topic.id}
          to={`/topic/${topic.id}`}
          className="group relative block rounded-lg overflow-hidden bg-primary-950 cursor-pointer"
        >
          <div className="relative w-full aspect-[16/10]">
            <img
              src={topic.cover}
              alt={`${topic.title} 专题封面`}
              title={`${topic.title} 影视专题合集`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/40 to-transparent"></div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
            <span className="inline-block px-2 py-0.5 rounded bg-accent-500 text-background-50 text-[11px] font-medium mb-2">
              精选专题
            </span>
            <h3 className="font-heading text-base font-bold text-background-50 line-clamp-1">
              {topic.title}
            </h3>
            <p className="mt-1.5 text-xs text-background-200 line-clamp-2">{topic.intro}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}